import {Injectable} from '@angular/core';

@Injectable()
export class BcaRequestModel {
    vaNumber: string;
    companyCode: string;
    customerNumber: string;
    requestID: string;
    customerName: string;
    currencyCode: string;
    totalAmount: string;
    subCompany: string;
}
